import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ProductsInventoryOptionsFormStyle from './css/ProductsInventoryOptionsFormStyle'
import ProductsInventoryController from '../reports/productsinventory/ProductsInventoryController'
import OutOfStockController from '../reports/outofstock/OutOfStockController'
import ProductsPriceListController from '../reports/productspricelist/ProductsPriceListController'
import ProductsWithExpirationsController from '../reports/products_with_expirations/ProductsWithExpirationsController'
import { getWarehouses, getProductsClassifications } from '../../../ReportsFunctions'

function ProductsInventoryOptionsForm(props) {
  const { app } = props
  const setContent = app.content[1]
  const [warehouses, setWarehouses] = useState(null)
  const [productsClassifications, setProductsClassifications] = useState(null)
  const [check, setCheck] = useState({ warehouse: { }, classification: { } })
  const [reloaded, setReloaded] = useState(false)
  const [warehouseSelectAll, setWarehouseSelectAll] = useState(true)
  const [classificationSelectAll, setClassificationSelectAll] = useState(true)
  const [warehouseClick, setWarehouseClick] = useState(false)
  const [classificationClick, setClassificationClick] = useState(false)

  const onClick = (e) => {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))

    if (e.target.id === 'btn-continue') {
      switch(props.rep) {
        case 'inventory':
          setContent(<ProductsInventoryController filter={check} />)
          break
        case 'out_of_stock':
          setContent(<OutOfStockController filter={check} />)
          break
        case 'price_list':
          setContent(<ProductsPriceListController filter={check} />)
          break
        case 'products_with_expirations':
          setContent(<ProductsWithExpirationsController filter={check} />)
          break
        default:
      }
    }
  }

  const onclickOptionsWarehouse = (e) => {
    const id = e.target.closest('.options-name-wrapper').id
    setCheck({...check, warehouse: { ...check.warehouse, [id] : (check.warehouse[id]) ? 0 : 1 }})
    setWarehouseClick(true)
  }

  const onclickOptionsClassification = (e) => {
    const id = e.target.closest('.options-name-wrapper').id
    setCheck({...check, classification: { ...check.classification, [id] : (check.classification[id]) ? 0 : 1 }})
    setClassificationClick(true)
  }

  const onClickSelectAllWarehouse = (e) => {
    setWarehouseSelectAll(!warehouseSelectAll)
    for (let warehouse of warehouses) {
      check.warehouse[warehouse.name] = (!warehouseSelectAll) ? 1 : 0
    }

    // Initiate rerender
    setReloaded(true)
  }

  const onClickSelectAllClassification = (e) => {
    setClassificationSelectAll(!classificationSelectAll)
    for (let classification of productsClassifications) {
      check.classification[classification] = (!classificationSelectAll) ? 1 : 0
    }

    // Initiate rerender
    setReloaded(true)
  }

  useEffect(() => {
    const init = async () => {
      const warehouse_list = await getWarehouses(app)
      const products_classifications = await getProductsClassifications(app)

      setWarehouses(warehouse_list)
      setProductsClassifications(products_classifications)

      if (warehouse_list) {
        for (let warehouse of warehouse_list) {
          check.warehouse[warehouse.name] = 1
        }
      }

      if (products_classifications) {
        for (let classification of products_classifications) {
          check.classification[classification] = 1
        }
      }

      setReloaded(true)
    }

    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    return(() => { setReloaded(false) })
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloaded])

  useEffect(() => {
    if (warehouseClick) {
      let keys = 0
      for (let key in check.warehouse) {
        keys += check.warehouse[key]
      }

      setWarehouseSelectAll(Boolean(keys))
    }
  }, [check.warehouse, warehouseClick])

  useEffect(() => {
    if (classificationClick) {
      let keys = 0
      for (let key in check.classification) {
        keys += check.classification[key]
      }

      setClassificationSelectAll(Boolean(keys))
    }
  }, [check.classification, classificationClick])

  return (
    <React.Fragment>
      <div className='options-wrapper'>
        <div className='warehouses-container'>
          <div><b>Warehouses</b></div>
          <button
            id='wh-select-all'
            onClick={onClickSelectAllWarehouse}
            className='options-name-wrapper top-anchor'>
            <span className='fai'>
              <FontAwesomeIcon icon={(warehouseSelectAll) ? 'check-square' : 'square'}/>
            </span>
            &nbsp;
            <div className='option-name'>Select All</div>
          </button>
          {
            (warehouses) ?
              warehouses.map(wh => (
                <button
                  key={wh._id}
                  id={wh.name}
                  onClick={onclickOptionsWarehouse}
                  className='options-name-wrapper'>
                  <span className='fai'>
                    <FontAwesomeIcon icon={(check.warehouse[wh.name]) ? 'check-square' : 'square'}/>
                  </span>
                  &nbsp;
                  <div className='option-name'>{wh.name}</div>
                </button>
              ))
            : null
          }
        </div>
        <div className='classification-container'>
          <div><b>Classifications</b></div>
          <button
            id='classification-select-all'
            onClick={onClickSelectAllClassification}
            className='options-name-wrapper'>
            <span className='fai'>
              <FontAwesomeIcon icon={(classificationSelectAll) ? 'check-square' : 'square'}/>
            </span>
            &nbsp;
            <div className='option-name'>Select All</div>
          </button>
          {
            (productsClassifications) ?
            productsClassifications.map((classification, index) => (
              <button
                key={index}
                id={classification}
                onClick={onclickOptionsClassification}
                className='options-name-wrapper'>
                <span className='fai'>
                  <FontAwesomeIcon icon={(check.classification[classification]) ? 'check-square' : 'square'}/>
                </span>
                &nbsp;
                <div className='option-name'>{classification}</div>
              </button>
            ))
            : null
          }
        </div>
      </div>
      <div className='action-button-container'>
        <button
          id='btn-continue'
          className={(warehouseSelectAll && classificationSelectAll) ? 'pospro-action-btn' : 'pospro-action-btn disabled-button'}
          disabled={!warehouseSelectAll || !classificationSelectAll}
          onClick={onClick}>
          Continue...
        </button>
        <button
          id='btn-close'
          className='pospro-action-btn bottom-anchor'
          onClick={onClick}>
          Close
        </button>
      </div>
      <ProductsInventoryOptionsFormStyle />
    </React.Fragment>
  )
}

export default React.memo(ProductsInventoryOptionsForm)